import React, {useContext, useState} from 'react';
import logo from "../../../../../assets/security-details-generate-sales-report.svg";
import styles from './consolidate-atp.module.scss';
import { SecurityContext } from "../../../../../context/security-context";
import { ATP_ARCHIVE_DONE, ATP_ARCHIVE_NOT_STARTED, ATP_ARCHIVE_ON_GOING, ATP_ARCHIVE_READY } from '../../../../../helpr/constants';
import SecurityService from "../../../../../services/security-service";
import { Spinner } from 'react-bootstrap';

const ConsolidateATP = () => {
	const { securityState } = useContext(SecurityContext);
	const securityService = new SecurityService();
	const [ action, setAction ] = useState(securityState.archiveStatus);
	const getActionName = (status) => {
		switch(status){
			case ATP_ARCHIVE_READY:
				return 'Consolidate ATP';
			case ATP_ARCHIVE_NOT_STARTED:
				return 'Consolidate ATP';
			case ATP_ARCHIVE_ON_GOING:
				return 'Generating Downloadable File..';
			case ATP_ARCHIVE_DONE:
				return 'Download ZIP';
		}
	}

	const downloadBatchATP = async () => {
		if(action === ATP_ARCHIVE_READY){
			setAction(ATP_ARCHIVE_ON_GOING);
		}
		const resp = await securityService.batchDownloadATP(securityState.securityId);;
		if(resp['status'] === 'ON_GOING'){
			setAction(ATP_ARCHIVE_ON_GOING);
		} else if(resp['status'] === 'DONE') {
			window.open(resp['s3PresignedUrl']);
			setAction(ATP_ARCHIVE_DONE);
		}
	}

	return (
		<div className={styles['logo']} onClick={()=>downloadBatchATP()}>
			{ action === ATP_ARCHIVE_ON_GOING
				? <label><Spinner animation="border" size="sm"/></label>
				:<img alt={getActionName(action)} src={logo}/> }
			<label>{getActionName(action)}</label>
		</div>
	)
}

export default ConsolidateATP;


